import { useEffect, useState } from "react";
import { Typography, Divider, Box } from "@mui/material";
import { languageLevelOptions, languageOptions } from "../../../commun/constants/options";
import DynamicForm from "../../../commun/DynamicForm";
import { STEP3_REQUIRED_FIELDS } from "./AddTalent";
import { fetchSkillsFromLightcast } from "../../../../services/lightcastApi"; 
import './Step3Form.css';

export default function Step3Form({ goToNextStep, goToPreviousStep, formData, setFormData, errors, setErrors }) {
  const competences = formData.competences;
  const langues = formData.langues;
  const [skillSuggestions, setSkillSuggestions] = useState([]);

  const [query, setQuery] = useState('');

  // Chargement dynamique des compétences via API Lightcast
  useEffect(() => {
    if (query.trim().length > 2) {
      const delayDebounce = setTimeout(() => {
        fetchSkillsFromLightcast(query.trim())
          .then((skills) => {
            setSkillSuggestions(skills || []);
          })
          .catch(console.error);
      }, 500);
      return () => clearTimeout(delayDebounce);
    } else {
      setSkillSuggestions([]);
    }
    
  }, [query]);

  const validateFields = () => {
    const newErrors = {};

    STEP3_REQUIRED_FIELDS.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = 'Veuillez remplir ce champ';
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateFields()) {
      setFormData(prev => ({
        ...prev,
        langues: langues,
        competences: competences,
      }));
      goToNextStep();
    }
  };

  const handleLangueChange = (index, field, value) => {
    const updated = [...formData.langues];
    updated[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      langues: updated,
    }));
  };

  const handleSkillInputChange = (input) => {
    setQuery(input);
  };
  
  const ajouterLangue = () => {
    setFormData((prev) => ({
      ...prev,
      langues: [...prev.langues, { langue: "", niveau: "" }],
    }));
  };

  const handleCertificatChange = (index, field, value) => {
    const updated = [...formData.certificats];
    updated[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      certificats: updated,
    }));
  };
  
  const ajouterCertificat = () => {
    setFormData((prev) => ({
      ...prev,
      certificats: [...(prev.certificats || []), { title: "", date: "" }],
    }));
  };
  
  const removeCertificat = (indexToRemove) => {
    setFormData((prev) => ({
      ...prev,
      certificats: prev.certificats.filter((_, idx) => idx !== indexToRemove),
    }));
  };

  const step3Config = [
    { type: "text", label: "Niveau d'études", name: "niveauEtudes" },
    { type: "text", label: "Diplôme", name: "titre" },
    { type: "text", label: "Date", name: "date" },
    { type: "text", label: "Établissement", name: "etablissement" },
    { type: "text", label: "Profil", name: "pointsEssentiels" },
    {
      type: "chip",
      label: "Compétences",
      name: "competences",
      suggestions: skillSuggestions,
      onInputChange: handleSkillInputChange,
    },
    { type: "textarea", label: "Résumé", name: "experienceTalent" , fullWidth: true },
    {
      type: "languageList",
      label: "Langues",
      name: "langues",
      options: {
        languages: (languageOptions || []).map(opt => opt.label),
        levels: (languageLevelOptions || []).map(opt => opt.label),
      },
      fullWidth: true
    },
    {
      type: "certificatList",
      label: "Certificats",
      name: "certificats",
      fullWidth: true
    }
  ];


  const removeLangue = (indexToRemove) => {
  setFormData((prev) => ({
    ...prev,
    langues: prev.langues.filter((_, idx) => idx !== indexToRemove)
  }));
};


  return (
    <Box className="step3-container">
      <Typography variant="h6" className="step3-title">
        Formation & compétences
      </Typography>
      <Divider className="step3-divider" />

      <DynamicForm
        fields={step3Config}
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        setErrors={setErrors}
        onNext={handleNextStep}
        onBack={goToPreviousStep}
        additionalProps={{
        langues,
        handleLangueChange: handleLangueChange,
        ajouterLangue: ajouterLangue,
        removeLangue,
        handleCertificatChange,   
        ajouterCertificat,        
        removeCertificat, 
        languageOptions,
        languageLevelOptions,
        
      }}

      />
    </Box>
  );
}
